export default __webpack_public_path__ + "static/nav-background-8366883b1c8c938dbb07565b29336607.png";